import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

const requiredField = (field:string) => Yup.string().required(` ${field} is required`);    
const passwordField = () =>
  requiredField('password')
    .min(
      8,
      'password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special'
    )
    .minLowercase(1, 'password must contain at least 1 lower case letter')
    .minUppercase(1, 'password must contain at least 1 upper case letter')
    .minNumbers(1, 'password must contain at least 1 number')
    .minSymbols(1, 'password must contain at least 1 special character');

export const LoginSchema = Yup.object().shape({
      
    email: Yup.string().email().required("Email is required"),
  
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password is too short - should be 6 chars minimum"),
  });

  export const forgotPasswordSchema = Yup.object().shape({
      
    email: Yup.string().email().required("Email is required"),
  });

  export const changePasswordSchema = Yup.object().shape({
      
    password: passwordField(),
    confirm_password: Yup.string().label('confirm password').required().oneOf([Yup.ref('password')], 'Passwords must match'),
    
  });